<template>
  <div class="layout layout-page-panel">
    <div class="layout__header">
      <slot name="header"></slot>
    </div>
    <div class="layout__body white-background">
      <div class="layout__tools">
        <slot name="tools"></slot>
      </div>
      <div class="layout__content">
        <template v-if="isEmpty">
          <div class="layout__empty">
            {{messageEmpty}}
          </div>
        </template>
        <template v-else>
          <slot name="content"></slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutPagePanel',
  props: {
    isEmpty: { type: Boolean, default: false },
    messageEmpty: { type: String }
  }
}
</script>

<style lang="stylus">
.layout-page-panel{
  .layout__header{
  }
  .layout__body{
    flex-grow: 1
    display: grid
    grid-template-areas:
      "tools"\
      "content"
    grid-template-rows auto 1fr
    grid-template-columns 100%
    grid-gap 0px
    padding 0
  }
  .layout__body{

  }
  .layout__tools{
    grid-area tools
    background #f2fbfe
    padding 0 15px
    position relative
    z-index 2
    padding-top 2rem
    padding-bottom 2rem
  }
  .layout__empty{
    display flex
    justify-content center
    align-items center
    height 100%
    color #6d7278
  }
  .layout__content{
    grid-area content
    background #fff
    padding-bottom 1rem
  }
}
</style>
